var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 4.875H4.875V11.125H3.625V4.875ZM9.25 4.875H9.875V11.125H9.25V4.875ZM6.75 4.875H8.625V11.125H6.75V4.875ZM5.5 4.875H6.125V11.125H5.5V4.875ZM10.5 4.875H12.375V11.125H10.5V4.875Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.625H5.5V2.375H3C2.31062 2.375 1.75 2.93562 1.75 3.625V6.125H3V3.625ZM3 13.625H5.5V12.375H3V9.875H1.75V12.375C1.75 13.0644 2.31062 13.625 3 13.625ZM13 2.375H10.5V3.625H13V6.125H14.25V3.625C14.25 2.93562 13.6894 2.375 13 2.375ZM13 12.375H10.5V13.625H13C13.6894 13.625 14.25 13.0644 14.25 12.375V9.875H13V12.375Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanners);
export default __webpack_public_path__ + "static/media/scanners.6782bdc25c6268db5d842365b1c2375c.svg";
export { ForwardRef as ReactComponent };